// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__hczuj","badge":"tabs_badge__PR6ji","badge-yellow":"tabs_badge-yellow__cYsTB","badge-green":"tabs_badge-green__w4rTS","badge-red":"tabs_badge-red__r9SJj"};